import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'work-ui-secret-reveal',
  templateUrl: './secret-reveal.component.html',
  styleUrls: ['./secret-reveal.component.scss'],
})
export class SecretRevealComponent implements OnInit {
  @Input() value: string | number | null = '******';
  public obfuscatedValue = '';
  public isRevealed = false;
  public containerWidth = 'auto';

  ngOnInit(): void {
    this.obfuscatedValue = this.obfuscate(this.value);
  }

  ionAfterViewInit() {
    this.setContainerWidth();
  }

  toggleReveal(): void {
    this.isRevealed = !this.isRevealed;
  }

  private obfuscate(value: string | number | null): string {
    return `${value}`.replace(/./g, '•');
  }

  private setContainerWidth(): void {
    const virtualSpan = document.createElement('span');
    virtualSpan.style.visibility = 'hidden';
    virtualSpan.style.position = 'absolute';
    virtualSpan.style.whiteSpace = 'nowrap';
    virtualSpan.style.pointerEvents = 'none';
    virtualSpan.textContent = `${this.value}`;
    document.body.appendChild(virtualSpan);
    const width = virtualSpan.offsetWidth;
    this.containerWidth = `${width}px`;
    document.body.removeChild(virtualSpan);
  }
}
